import React from 'react';
import { Button, useTheme } from '@mui/material';
import { RiAddCircleLine } from 'react-icons/ri';

export interface AddOnPromoBlockProps {
	text: string;
	onClick: () => void;
}

const UpgradeButton = (props: AddOnPromoBlockProps) => {
	const { text, onClick } = props;
	const theme = useTheme();
	return (
		<Button
			variant="text"
			startIcon={<RiAddCircleLine color={theme.palette.success.main} />}
			onClick={onClick}
			sx={{
				mt: 2,
				mb: 2,
				color: (theme) => theme.palette.colors.tundra.main,
				'&:hover': {
					color: (theme) => theme.palette.colors.tundra.main,
				},
			}}
		>
			{text}
		</Button>
	);
};

export default UpgradeButton;
